export const executeSync = (targetFunction) => {
    return new Promise((resolve, reject) => {
        return resolve(targetFunction())})
};